var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-menu', {
    ref: "menu",
    attrs: {
      "bottom": "",
      "offset-y": "",
      "close-on-content-click": false
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (_ref) {
        var on = _ref.on,
          attrs = _ref.attrs;
        return [_c('v-text-field', _vm._g(_vm._b({
          class: _vm.contentClass,
          attrs: {
            "outlined": "",
            "dense": "",
            "hide-details": "",
            "persistent-placeholder": "",
            "clearable": "",
            "label": `Search${_vm.selectedGroups.length ? ' (within ' + _vm.selectedGroups.length + ' group' + (_vm.selectedGroups.length == 1 ? '' : 's') + ')' : ''}`,
            "placeholder": _vm.advanced ? 'Advanced search' : null,
            "disabled": _vm.disabled,
            "append-icon": _vm.mdiMagnify,
            "readonly": _vm.advanced,
            "value": _vm.advanced ? '' : _vm.searchText,
            "loading": _vm.loading
          },
          on: {
            "input": function (v) {
              return _vm.searchText = v;
            },
            "click:append": function ($event) {
              _vm.advanced ? _vm.searchAdvanced() : _vm.searchBasic();
            },
            "click:clear": function ($event) {
              _vm.$nextTick(function () {
                return _vm.$nextTick(_vm.searchBasic);
              });
            },
            "keydown": function ($event) {
              if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
              return _vm.searchBasic.apply(null, arguments);
            }
          }
        }, 'v-text-field', attrs, false), on))];
      }
    }]),
    model: {
      value: _vm.showAdvancedMenu,
      callback: function ($$v) {
        _vm.showAdvancedMenu = $$v;
      },
      expression: "showAdvancedMenu"
    }
  }, [_c('div', {
    staticClass: "pt-2 pb-3 px-2 grey lighten-4 overflow-auto",
    staticStyle: {
      "max-height": "calc(100vh - 24px)"
    }
  }, [!_vm.hideGroups ? [_c('div', {
    staticClass: "pl-2 d-flex align-center"
  }, [_c('div', {
    staticClass: "text--label-active"
  }, [_vm._v("Groups")])]), _c('v-list', {
    staticClass: "transparent mx-n2",
    attrs: {
      "dense": ""
    }
  }, _vm._l(_vm.groups, function (g) {
    var _vm$groupContext;
    return _c('v-list-item', {
      key: g.id,
      attrs: {
        "input-value": _vm.selectedGroups.find(function (x) {
          return x == g.id;
        }),
        "disabled": ((_vm$groupContext = _vm.groupContext) === null || _vm$groupContext === void 0 ? void 0 : _vm$groupContext.id) == g.id
      },
      on: {
        "click": function ($event) {
          return _vm.toggleSearchGroup(g);
        }
      }
    }, [_c('v-list-item-title', {
      domProps: {
        "textContent": _vm._s(g.name)
      }
    }), _c('v-list-item-icon', {
      staticClass: "ml-4 mr-1",
      staticStyle: {
        "height": "28px"
      }
    }, [_vm.selectedGroups.find(function (x) {
      return x == g.id;
    }) ? _c('v-icon', {
      domProps: {
        "innerHTML": _vm._s(_vm.mdiCheck)
      }
    }) : _vm._e()], 1)], 1);
  }), 1)] : _vm._e(), _c('div', {
    staticClass: "px-1 d-flex align-center"
  }, [_c('v-switch', {
    staticClass: "mt-0",
    attrs: {
      "dense": "",
      "hide-details": ""
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function () {
        return [_c('div', {
          staticClass: "text--label-active mr-3"
        }, [_vm._v("Advanced search options")])];
      },
      proxy: true
    }]),
    model: {
      value: _vm.advanced,
      callback: function ($$v) {
        _vm.advanced = $$v;
      },
      expression: "advanced"
    }
  }), _c('v-spacer'), !_vm.advanced && !_vm.hideGroups ? _c('v-btn', {
    attrs: {
      "small": "",
      "color": "primary"
    },
    on: {
      "click": _vm.searchBasic
    }
  }, [_vm._v("Search")]) : _vm._e()], 1), _vm.advanced ? _c('div', {
    staticClass: "pt-3"
  }, [_c('v-form', {
    model: {
      value: _vm.isValid,
      callback: function ($$v) {
        _vm.isValid = $$v;
      },
      expression: "isValid"
    }
  }, _vm._l(_vm.search.fields, function (field, i) {
    return _c('div', {
      staticClass: "d-flex align-center my-2"
    }, [_c('v-btn', {
      attrs: {
        "icon": "",
        "small": ""
      },
      on: {
        "click": function ($event) {
          _vm.search.removed.push(field.key);
          _vm.search.fields.splice(i, 1);
        }
      }
    }, [_c('v-icon', {
      domProps: {
        "innerHTML": _vm._s(_vm.mdiClose)
      }
    })], 1), _c('code', {
      staticClass: "mx-2"
    }, [_vm._v(_vm._s(field.key))]), _c(_vm.getComponent(field.type), {
      tag: "component",
      staticClass: "mt-0",
      attrs: {
        "dense": "",
        "hide-details": "",
        "rules": field.type == 'pattern' ? [_vm.isValidRe] : []
      },
      scopedSlots: _vm._u([{
        key: "append-outer",
        fn: function () {
          return [_c('v-menu', {
            attrs: {
              "bottom": "",
              "offset-y": ""
            },
            scopedSlots: _vm._u([{
              key: "activator",
              fn: function (_ref2) {
                var on = _ref2.on,
                  attrs = _ref2.attrs;
                return [_c('v-btn', _vm._g(_vm._b({
                  directives: [{
                    name: "blur",
                    rawName: "v-blur"
                  }],
                  staticClass: "px-0",
                  attrs: {
                    "text": "",
                    "x-small": ""
                  }
                }, 'v-btn', attrs, false), on), [_c('v-icon', {
                  attrs: {
                    "small": ""
                  },
                  domProps: {
                    "innerHTML": _vm._s(_vm.SEARCH_FIELD_TYPES[field.type])
                  }
                }), _c('v-icon', {
                  attrs: {
                    "small": ""
                  },
                  domProps: {
                    "innerHTML": _vm._s(_vm.mdiMenuDown)
                  }
                })], 1)];
              }
            }], null, true)
          }, [_c('v-list', {
            attrs: {
              "dense": ""
            }
          }, _vm._l(_vm.SEARCH_FIELD_TYPES, function (icon, type) {
            return _c('v-list-item', {
              key: type,
              staticClass: "overline short",
              attrs: {
                "input-value": field.type == type,
                "disabled": type != 'pattern' && _vm.FIXED_FIELD_TYPES[field.key] && _vm.FIXED_FIELD_TYPES[field.key] != type
              },
              on: {
                "click": function ($event) {
                  field.type = type;
                }
              }
            }, [_c('v-icon', {
              staticClass: "mr-2",
              domProps: {
                "innerHTML": _vm._s(icon)
              }
            }), _vm._v(" " + _vm._s(type) + " "), _c('v-spacer'), type == 'pattern' ? _c('v-btn', {
              staticClass: "mr-n2",
              attrs: {
                "icon": ""
              },
              on: {
                "click": function ($event) {
                  $event.stopPropagation();
                  return _vm.$confirm({
                    title: 'Pattern',
                    msg: `A <a href='https://docs.python.org/3/library/re.html' target='_blank'>regular expression pattern</a> is specialized text that allows for describing and searching complex conditions. Please use another search option if you're unfamiliar with regular expressions.`,
                    buttons: ['Ok'],
                    primary: 'Ok'
                  });
                }
              }
            }, [_c('v-icon', {
              domProps: {
                "innerHTML": _vm._s(_vm.mdiHelpCircle)
              }
            })], 1) : _vm._e()], 1);
          }), 1)], 1)];
        },
        proxy: true
      }], null, true),
      model: {
        value: field.value,
        callback: function ($$v) {
          _vm.$set(field, "value", $$v);
        },
        expression: "field.value"
      }
    })], 1);
  }), 0), _c('div', {
    staticClass: "d-flex align-center my-2"
  }, [_c('v-menu', {
    attrs: {
      "right": "",
      "offset-x": "",
      "nudge-right": "8",
      "nudge-top": "6",
      "close-on-content-click": false
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (_ref3) {
        var on = _ref3.on,
          attrs = _ref3.attrs;
        return [_c('v-btn', _vm._g(_vm._b({
          directives: [{
            name: "blur",
            rawName: "v-blur"
          }],
          attrs: {
            "icon": "",
            "small": ""
          }
        }, 'v-btn', attrs, false), on), [_c('v-icon', {
          domProps: {
            "innerHTML": _vm._s(_vm.mdiPlus)
          }
        })], 1)];
      }
    }], null, false, 3004035058),
    model: {
      value: _vm.showAddFieldMenu,
      callback: function ($$v) {
        _vm.showAddFieldMenu = $$v;
      },
      expression: "showAddFieldMenu"
    }
  }, [_c('v-card', [_vm.showAddFieldMenu ? _c('v-combobox', {
    attrs: {
      "outlined": "",
      "dense": "",
      "hide-details": "",
      "placeholder": "",
      "persistent-placeholder": "",
      "items": Object.keys(_vm.types)
    },
    on: {
      "input": function (key) {
        _vm.search.removed = _vm.search.removed.filter(function (x) {
          return x == key;
        });
        _vm.search.fields.push({
          key,
          type: _vm.FIXED_FIELD_TYPES[key] || 'text',
          value: ''
        });
        _vm.showAddFieldMenu = false;
      }
    }
  }) : _vm._e()], 1)], 1)], 1), _c('div', {
    staticClass: "mt-5 d-flex flex-wrap align-center"
  }, [_c('v-radio-group', {
    staticClass: "mt-0 pt-0",
    staticStyle: {
      "padding-left": "2px"
    },
    attrs: {
      "row": "",
      "dense": "",
      "hide-details": ""
    },
    model: {
      value: _vm.advancedMode,
      callback: function ($$v) {
        _vm.advancedMode = $$v;
      },
      expression: "advancedMode"
    }
  }, [_c('v-radio', {
    attrs: {
      "value": "OR"
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function () {
        return [_c('span', {
          staticClass: "text--label-active"
        }, [_vm._v("Match any")])];
      },
      proxy: true
    }], null, false, 3781454873)
  }), _c('v-radio', {
    attrs: {
      "value": "AND"
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function () {
        return [_c('span', {
          staticClass: "text--label-active"
        }, [_vm._v("Match all")])];
      },
      proxy: true
    }], null, false, 4508974)
  })], 1), _c('v-spacer'), _c('v-btn', {
    attrs: {
      "small": "",
      "color": "primary",
      "disabled": !_vm.isValid
    },
    on: {
      "click": _vm.searchAdvanced
    }
  }, [_vm._v("Search")])], 1)], 1) : _vm._e()], 2)]);

}
var staticRenderFns = []

export { render, staticRenderFns }